// src/features/whatsapp/pages/MembershipExpiredPage.tsx
// Membresías F4 (20-oct-2026): aviso «vencida» que manda el cron una vez cuando la membresía venció o se agotó el cupo
// (y el cliente no renovó). Canal excluyente: correo (por defecto) o WhatsApp. Se enciende por PLAN desde Membresías.
import React from 'react';
import { BadgeCheck } from 'lucide-react';
import EventMessageEditor from '../components/EventMessageEditor';

const MembershipExpiredPage: React.FC = () => (
  <EventMessageEditor
    eventKey="membership_expired"
    title="Aviso de Membresía Vencida"
    subtitle="Cuando una membresía venció o se acabaron sus productos incluidos y el cliente no renovó, invítalo a volver"
    icon={<BadgeCheck className="h-5 w-5 sm:h-6 sm:w-6 mr-2 text-amber-500" />}
    feature="Avisos de membresía"
    defaultTemplate="Hola @nombre, tu membresía @membresia en @negocio venció @vence. Cuando quieras renovarla, pasa con nosotros y seguimos 🎟️"
    variables={[
      { key: '@nombre', label: 'Nombre del cliente', example: 'María' },
      { key: '@membresia', label: 'Nombre del plan', example: 'Club del Café' },
      { key: '@vence', label: 'Cuándo venció', example: 'el 19 nov' },
      { key: '@negocio', label: 'Nombre de tu negocio', example: 'tu negocio', aliases: ['@marca'] },
    ]}
    enabledHint={{ on: 'Los miembros cuya membresía venció reciben este mensaje', off: 'Activar para invitar a renovar cuando una membresía venció' }}
    stepGuide={{
      description: 'Cada día el sistema cierra las membresías que vencieron o se quedaron sin productos incluidos. Si el plan tiene el aviso encendido y el cliente no tiene otra membresía vigente, le manda este mensaje una sola vez.',
      steps: ['Membresía vencida o agotada', 'Sin renovación', 'Correo o WhatsApp al cliente'],
    }}
    requirementsReady="Todo listo — tus miembros sabrán cuando su membresía venza"
    emailWithoutWhatsapp
    emailChannel={{ defaultSubject: 'Tu membresía @membresia venció' }}
  />
);

export default MembershipExpiredPage;
